// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1cvDH","approved":"Status_approved__2zWzH","rejected":"Status_rejected__12Biq","expired":"Status_expired__1QGru","label":"Status_label__2IcjO"};